/**
 * Firebase web config — proje: octo-ai-68060
 * Flutter app ile aynı Firebase projesini kullanır.
 *
 * Web appId Console'da yoksa Android istemci kimliği initialize için yeter;
 * Google girişinin çalışması için Auth'ta Google provider + localhost domain gerekir.
 */
export const firebaseConfig = {
    apiKey: "AIzaSyCpr_sYnXxZ1-7-WFm5YlOOlbXlQzFk1b4",
    authDomain: "octo-ai-68060.firebaseapp.com",
    projectId: "octo-ai-68060",
    storageBucket: "octo-ai-68060.firebasestorage.app",
    messagingSenderId: "1091973670499",
    appId: "1:1091973670499:web:b3f236fe54e7fd20fb3a56",
    measurementId: "G-84F9C4FFTR"
};
